import React from 'react';
import LoadingIcon from '../../assets/img/loading_transp.gif';
// javascript plugin used to create scrollbars on windows

const LoadingSkeleton = ({ lines, style }) => {
  return (
    <div style={style}>
      <img src={LoadingIcon} width={40} />&nbsp;&nbsp;Lädt
    </div>
  );
};

export default LoadingSkeleton;
